var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-block",style:(_vm.myBlockProps.getStyles(_vm.visible))},[_c('span',{style:(_vm.myTextProps.getStyles())},[_vm._v(_vm._s(_vm.myText.getText(_vm.selectedLanguage)))])])}
var staticRenderFns = []

export { render, staticRenderFns }